import React, { useEffect, useState, useCallback } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import SearchBar from '../../components/common/SearchBar';
import Pagination from '../../components/common/Pagination';
import { getUseHistoryList } from '../../api/history';
import { formatDateTime } from '../../utils/format';

export default function UseHistoryPage() {
  const [condition, setCondition] = useState({ pageNo: 1, pageSize: 15 });
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchList = useCallback(async (cond) => {
    setLoading(true);
    setError('');
    try {
      const res = await getUseHistoryList(cond);
      setPage(res.data);
    } catch (err) {
      setError(err.response?.data?.message || '사용 이력을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchList(condition); }, [condition, fetchList]);

  return (
    <AdminLayout title="사용이력관리" menuUrl="/admin/history/use">
      <div className="page-header">
        <div>
          <h1>사용이력관리</h1>
          <div className="subtitle">관리자의 화면/기능 사용(작업) 이력을 조회합니다.</div>
        </div>
      </div>

      <div className="list-toolbar">
        <SearchBar placeholder="관리자 계정으로 검색" useDateRange
          onSearch={(cond) => setCondition((c) => ({ ...c, adminAccount: cond.searchKeyword, searchStartDate: cond.searchStartDate, searchEndDate: cond.searchEndDate, pageNo: 1 }))} />
      </div>

      <div className="list-count-bar">
        <span className="list-count">전체 <b>{page?.totalCount ?? 0}</b>건</span>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="data-table">
            <thead><tr><th>계정</th><th>메뉴</th><th>작업유형</th><th>상세</th><th>접속 IP</th><th>일시</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="empty-row">불러오는 중...</td></tr>}
              {!loading && error && <tr><td colSpan={6} className="empty-row error-state">{error}</td></tr>}
              {!loading && !error && page?.list?.length === 0 && <tr><td colSpan={6} className="empty-row">이력이 없습니다.</td></tr>}
              {!loading && !error && page?.list?.map((h) => (
                <tr key={h.useHistId}>
                  <td>{h.adminAccount}</td>
                  <td>{h.menuCode || '-'}</td>
                  <td>{h.actionType}</td>
                  <td className="text-secondary">{h.actionDesc || '-'}</td>
                  <td>{h.clientIp}</td>
                  <td>{formatDateTime(h.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {page && <Pagination {...page} onChange={(pageNo) => setCondition((c) => ({ ...c, pageNo }))} />}
    </AdminLayout>
  );
}
